export default __webpack_public_path__ + "static/media/terrible.4bd89b70.svg";